import * as React from "react";
import { Icon } from "../Icon/icon";

export interface ILinkPuffProps {
  heading: string;
  link: string;
  text: string;
  cssClass?: string;
  isFMK?: boolean;
  isPublic?: boolean;
}

export class LinkPuff extends React.Component<ILinkPuffProps> {
  static defaultProps = {
    cssClass: "",
  };

  public render() {
    const { cssClass, heading, link, text, isFMK, isPublic } = this.props;
    return (
      <>
        {isFMK || isPublic ? (
          <a className={`${cssClass}`} href={link}>
            <h2>
              {heading}
              <Icon className="" iconType="fontawesome/chevron-left" />
            </h2>
            {text && (
              <div
                dangerouslySetInnerHTML={{ __html: text }}
                className="linkedpuff__text"
              ></div>
            )}
          </a>
        ) : (
          <div className={`${cssClass}`}>
            {link !== "" ? (
              <a href={link}>
                <h2>
                  {heading}
                  <Icon className="" iconType="fontawesome/chevron-left" />
                </h2>
              </a>
            ) : (
              <h2>
                {heading}
                <Icon className="" iconType="fontawesome/chevron-left" />
              </h2>
            )}
            {text && (
              <div
                dangerouslySetInnerHTML={{ __html: text }}
                className="linkedpuff__text"
              ></div>
            )}
          </div>
        )}
      </>
    );
  }
}
